<template>
  <div v-if="container" class="ambi-separator">
    <div class="Container">
      <div class="Row">
        <div class="Col w-full">
          <div class="h-px bg-border-common" :class="lineColor"></div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="ambi-separator">
    <div class="h-px" :class="lineColor"></div>
  </div>
</template>

<script>
export default {
  props: {
    container: {
      type: Boolean,
      default: false
    },

    theme: {
      type: String,
      default: 'dark' // light / dark / red
    }
  },
  computed: {
    lineColor() {
      if (this.theme == 'light') {
        return 'bg-ambi-gray-dark'
      }
      if (this.theme == 'dark') {
        return 'bg-border-common'
      }
      if (this.theme == 'red') {
        return 'bg-ambi-red'
      }

      return null
    }
  }
}
</script>

<style lang="scss" scoped></style>
